import { Icons, tokens, Box } from '@cast/design-system';

export const NavTriggerCaret = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      color: tokens.theme.fg.structural.secondary,
    }}
  >
    <Icons.CaretDown size={12} weight="regular" color="currentColor" />
  </Box>
);
